import treasureChestImage from 'src/images/pngs/campaigns/hack2win-flash-sale/treasure-chest.png';
import styled, { css } from 'styled-components';

export const StyledBanner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 38.5rem;
  padding: 3rem 1.8rem 18rem;
  position: relative;
  overflow: hidden;
  background: linear-gradient(91deg, #1C2538 42.32%, #3D63AE 99.39%);

  z-index: 0;

  @media screen and (min-width: 576px) {
    padding: 4.6rem;
    align-items: flex-start;
  }

  & > div {
    z-index: 10;
  }
`;

export const StyledHeading = styled.div<{ $large: boolean }>`
  display: flex;
  flex-direction: column;

  max-width: ${({ $large: $big }) => ($big ? '65rem' : '54rem')};
  @media screen and (max-width: 576px) {
    max-width: 100%;
  }
`;

export const StyledTitle = styled.h2`
  color: ${({ theme }) => theme.colors.text.main};
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  margin-bottom: 0rem;

  font-size: ${({ theme }) => theme.fonts.sizes.subTitle};
  line-height: 3.7rem;
  text-align: left;

  span {
    color: ${({ theme }) => theme.colors.primary.main};
  }

  @media screen and (max-width: 576px) {
    font-size: ${({ theme }) => theme.fonts.sizes.large};
    text-align: center;
    line-height: 2.8rem;
    max-width: 100%;
  }
`;

export const StyledSubTitle = styled.h3`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
  margin-bottom: 0rem;
  margin-top: 1.6rem;

  text-align: left;
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  line-height: 2.3rem;
  max-width: 45.1rem;

  span {
    color: ${({ theme }) => theme.colors.primary.main};
    font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  }

  @media screen and (max-width: 576px) {
    text-align: center;
    font-size: ${({ theme }) => theme.fonts.sizes.default};
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
    line-height: 2rem;
    max-width: 100%;
  }
`;

export const StyledSubTitleAlt = styled(StyledSubTitle)`
  font-size: ${({ theme }) => theme.fonts.sizes.large};
  line-height: 3rem;
  max-width: 100%;

  @media screen and (max-width: 576px) {
    font-size: ${({ theme }) => theme.fonts.sizes.medium};
    line-height: 2.3rem;
  }
`;

export const StyledButtons = styled.div`
  display: flex;
  gap: 1.6rem;
  padding-top: 1.6rem;
`;

export const StyledCountdownContainer = styled.div`
  padding: 2.4rem 0rem 1.6rem;
`;

export const StyledTreasureChestImg = styled.img.attrs({
  src: treasureChestImage,
})<{ $large: boolean }>`
  position: absolute;
  z-index: 1;

  ${({ $large }) =>
    $large
      ? css`
    width: 55rem;
    right: 0rem;
    bottom: 50%;
    transform: translateY(50%);
  `
      : css`
    width: 42.1rem;
    bottom: 0;
    right: -2.1rem;
    transform: none;
  `}

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    width: 42.1rem;
    bottom: 0;
    right: -2.1rem;
    transform: none;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    width: 35.5rem;
    right: -1.8rem;
    bottom: 0;
    transform: none;
  }

  @media screen and (max-width: 576px) {
    width: 33.7rem;
    bottom: -6rem;
    right: 50%;
    transform: translateX(50%);
  }
`;
